import { render, staticRenderFns } from "./BlockType16.vue?vue&type=template&id=52eb7ce8&scoped=true"
import script from "./BlockType16.vue?vue&type=script&lang=ts"
export * from "./BlockType16.vue?vue&type=script&lang=ts"
import style0 from "./BlockType16.vue?vue&type=style&index=0&id=52eb7ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb7ce8",
  null
  
)

export default component.exports